import { React, useState, useEffect } from 'react'
import { Box, Typography, useMediaQuery, Icon, Card, Divider, Skeleton } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const DataTable = ({ staffData }) => {
  const [isLoading, setIsLoading] = useState(true)
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  const errors = staffData?.errors

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 2000)
  }, [])

  return (
    <>
      {staffData?.errors_count === 0 ? (
        <Card
          variant="outlined"
          sx={{
            backgroundColor: 'white.main',
            width: '100%',
            maxHeight: '300px',
          }}
        >
          <Box p={2} display="flex" alignItems="center">
            <Icon sx={{ color: 'alternate.main', mr: 1 }}>check_circle</Icon>
            <Typography>No errors found! You can proceed by clicking the button below.</Typography>
          </Box>
        </Card>
      ) : (
        <Card
          variant="outlined"
          sx={{
            backgroundColor: 'white.main',
            maxWidth: '100%',
            maxHeight: '300px',
            overflowY: 'auto',
          }}
        >
          {errors &&
            errors?.map((item, index) => (
              <>
                {isLoading ? (
                  matches ? (
                    <>
                      <Box width={'100%'} display={'flex'}>
                        <Box p={2} mr={6}>
                          <Skeleton height={30} width={150} />
                        </Box>
                        <Box p={2} mr={6}>
                          <Skeleton height={30} width={150} />
                        </Box>
                        <Box p={2} mr={6}>
                          <Skeleton height={30} width={150} />
                        </Box>
                      </Box>
                      <Divider light />
                    </>
                  ) : (
                    <>
                      <Box display={'flex'} flexDirection={'row'} width="100%">
                        <Box p={2} width="50%">
                          <Skeleton height={50} width={'100%'} />
                        </Box>
                        <Box p={2} width="50%">
                          <Skeleton height={50} width={'100%'} />
                        </Box>
                      </Box>

                      <Divider light />
                    </>
                  )
                ) : (
                  <>
                    {' '}
                    <Box py={2} pl={3} key={index} display={'flex'} alignItems={'center'}>
                      <Box
                        sx={{ minWidth: '150px' }}
                        width={1 / 8}
                        display={'flex'}
                        flexDirection={'row'}
                        alignItems={'center'}
                      >
                        <Icon sx={{ color: 'error.main', mr: 1 }}>error</Icon>

                        <Typography align="center" variant="subtitle1" color="dark-gray-text.main">
                          {item.staff_id}
                        </Typography>
                      </Box>

                      <Box sx={{ minWidth: '150px' }} width={1 / 6}>
                        <Typography variant="subtitle1" color="dark-gray-text.main">
                          {item.staff_name}
                        </Typography>
                      </Box>

                      <Box sx={{ minWidth: '150px', pl: 4 }}>
                        <Typography variant="subtitle1" color="error.main">
                          {item.errors}
                        </Typography>
                      </Box>
                    </Box>
                    <Divider light sx={{ width: '100vw' }} />
                  </>
                )}
              </>
            ))}
        </Card>
      )}
    </>
  )
}

export default DataTable
